import { createTheme } from '@mui/material/styles';
import globalStyles from './global';
import { getResponsiveHeight, getResponsiveSize } from './utils/responsive';

const getResponsiveFontSize = () => ({
  '@media (min-width: 1200px)': {
    fontSize: '55px', 
    lineHeight: '55px',
  },
  '@media (min-width: 600px) and (max-width: 1199.98px)': {
    fontSize: '36px', 
    lineHeight: '32px',
  },
  '@media (max-width: 599.98px)': {
    fontSize: '30px', 
    lineHeight: '26px',
  },
});
const getResponsiveSubtitleFontSize = () => ({
  '@media (min-width: 1200px)': {
    fontSize: '20px',   // Large screens (md and up)
    lineHeight: '30px',
  },
  '@media (min-width: 600px) and (max-width: 1199.98px)': {
    fontSize: '16px',   // Small screens (sm)
    lineHeight: '22px',
  },
  '@media (max-width: 599.98px)': {
    fontSize: '12px',   // Extra small screens (xs)
    lineHeight: '16px',
  },
});


const theme = createTheme({
  typography: {
    h1: {
      color: globalStyles.colors.army_green,
      fontSize: getResponsiveSize(45),
      fontFamily: ' "Poppins", serif ',
      fontWeight: '700',
      lineHeight: 1.2,
      marginTop: getResponsiveHeight(8),
      marginBottom: getResponsiveHeight(5),
    },
      h1_gothic: {
      color: globalStyles.colors.army_green,
      fontFamily: '"AllRoundGothicBold"',
      fontWeight: '700',
      lineHeight: 1.2,
      marginTop: getResponsiveHeight(8),
      marginBottom: getResponsiveHeight(5),
    },
    title_banner : {
  color: globalStyles.colors.white,
  fontFamily: '"AllRoundGothicBold", AllRoundGothic-Bold, sans-serif',
  fontWeight: 400,
  marginTop: getResponsiveHeight(8),
  marginBottom: getResponsiveHeight(5),
  letterSpacing: '1%',
  textTransform: 'uppercase',
  textAlign: 'center',
  ...getResponsiveFontSize(),
},
subtitle_banner :{
  color: '#FFFFFF',
  fontFamily: '"Poppins", sans-serif',
  fontWeight: 400,
  letterSpacing: '0%',
  textAlign: 'center',
  ...getResponsiveSubtitleFontSize(),
},
    h1_white: {
      color: globalStyles.colors.white,
      fontSize: getResponsiveSize(45),
      fontFamily: ' "Poppins", serif ',
      fontWeight: '700',
      lineHeight: 1.2,
      marginTop: getResponsiveHeight(8),
      marginBottom: getResponsiveHeight(5),
    },
    h1_howitworks: {
      color: globalStyles.colors.white,
      fontSize: getResponsiveSize(40),
      fontFamily: ' "Poppins", serif ',
      fontWeight: '700',
      lineHeight: 1.2,
      marginTop: getResponsiveHeight(8),
      marginBottom: getResponsiveHeight(5),
    },
    h1_center: {
      color: globalStyles.colors.army_green,
      fontSize: getResponsiveSize(45),
      fontFamily: ' "Poppins", serif ',
      fontWeight: '700',
      lineHeight: 1.2,
      borderRight: '1px solid rgba(234, 240, 234, 1)',
      marginTop: getResponsiveHeight(8),
      marginBottom: getResponsiveHeight(5),
      textAlign: 'center',
    },
    h2: {
      color: globalStyles.colors.army_green,
      fontSize: getResponsiveSize(45 * 0.7),
      fontFamily: ' "Poppins", serif ',
      fontWeight: '700',
      lineHeight: 1.2,
      marginTop: getResponsiveHeight(8),
      marginBottom: getResponsiveHeight(5),
    },
    medium: {
      fontFamily: ' "Poppins", serif ',
      fontWeight: 500,
      fontSize: {
        xs: getResponsiveSize(20 * 0.7),
        md: getResponsiveSize(20 * 0.8),
        lg: getResponsiveSize(20),
      },
      color: globalStyles.colors.uclean_medium_gray,
    },
    bold: {
      fontFamily: ' "Poppins", serif ',
      fontWeight: '700',
      fontSize: getResponsiveSize(60),
      color: globalStyles.colors.uclean_gold,
    },
    regular: {
      fontFamily: ' "Poppins", serif ',
      fontWeight: 400,
      fontSize: {
        xs: getResponsiveSize(18 * 0.7),
        md: getResponsiveSize(18 * 0.8),
        lg: getResponsiveSize(18),
      },
      color: globalStyles.colors.white,
      textAlign: 'center',
    },

    regular_text: {
      fontFamily: ' "Poppins", serif ',
      fontWeight: 400,
      fontSize: {
        xs: getResponsiveSize(18 * 0.7),
        md: getResponsiveSize(18 * 0.8),
        lg: getResponsiveSize(18),
      },
      color: globalStyles.colors.uclean_medium_gray,
    },
    regular_text_ur: {
      fontFamily: ' "Poppins", serif ',
      fontWeight: 500,
      color: globalStyles.colors.uclean_medium_gray,
    },
    regular_gray: {
      fontFamily: ' "Poppins", serif ',
      fontWeight: 400,
      fontSize: {
        xs: getResponsiveSize(18 * 0.7),
        md: getResponsiveSize(18 * 0.8),
        lg: getResponsiveSize(18),
      },
      color: globalStyles.colors.uclean_works,
    },
    small_text: {
      fontFamily: ' "Poppins", serif ',
      fontWeight: 400,
      fontSize: {
        xs: getResponsiveSize(18 * 0.7),
        md: getResponsiveSize(18 * 0.8),
        lg: getResponsiveSize(18),
      },
      color: globalStyles.colors.white,
    },
    phone_text: {
      fontFamily: ' "Poppins", serif ',
      fontWeight: 400,
      fontSize: {
        xs: getResponsiveSize(18 * 0.7),
        md: getResponsiveSize(18 * 0.8),
        lg: getResponsiveSize(18),
      },
      color: globalStyles.colors.army_green,
    },
    small: {
      color: '#686868',
      fontSize: getResponsiveSize(12),
      fontFamily: 'Poppins, sans-serif',
    },
    body2: {
      fontFamily: 'Poppins, sans-serif',
      fontWeight: 300,
    },
    button: {
      fontFamily: 'Poppins, sans-serif',
      fontWeight: 500,
      textTransform: 'none', // This prevents automatic uppercase transformation
    },
  },
});

export default theme;
